const AMOUNT = /(\d{1,3}(?:\.\d{3})*,\d{2}|\d{2,6}(?:,\d{2})?)/g
const NOSSO_RE = /(?:nosso\s+pre[cç]o(?:\s+de\s+outlet)?|pre[cç]o\s+de\s+outlet|pre[cç]o\s+de\s+promo|outlet)\s*[:-]?\s*(?:r\$\s*)?(\d{1,3}(?:\.\d{3})*,\d{2}|\d{2,6}(?:,\d{2})?)/gi
const STORE_RE = /pre[cç]o\s+de\s+loja[^\d]{0,32}(?:r\$\s*)?(\d{1,3}(?:\.\d{3})*,\d{2}|\d{2,6}(?:,\d{2})?)/gi

export function parseBrl(raw) {
  const s = String(raw || '').trim().replace(/ /g, '')
  if (!s) return null
  const n = s.includes(',')
    ? Number(s.replace(/\./g, '').replace(',', '.'))
    : Number(s)
  if (!Number.isFinite(n) || n < 20 || n > 500000) return null
  return n
}

export function parsePaintedPrice(text) {
  const blob = String(text || '').replace(/\u00a0/g, ' ')
  const nosso = [...blob.matchAll(NOSSO_RE)].map((m) => parseBrl(m[1])).filter((n) => n != null)
  const store = [...blob.matchAll(STORE_RE)].map((m) => parseBrl(m[1])).filter((n) => n != null)
  let our = nosso.length ? nosso[nosso.length - 1] : null
  if (our == null) {
    const nums = [...blob.matchAll(AMOUNT)].map((m) => parseBrl(m[1])).filter((n) => n != null)
    if (store.length && nums.length) {
      const leftovers = nums.filter((n) => !store.includes(n))
      our = leftovers.length ? Math.min(...leftovers) : null
    } else if (nums.length >= 2) {
      our = Math.min(...nums)
    } else if (nums.length === 1 && !store.length) {
      our = nums[0]
    }
  }
  return {
    our_price: our,
    store_price: store.length ? store[store.length - 1] : null,
    raw: blob.slice(0, 800),
  }
}

export function urlKey(url) {
  return String(url || '').split('?')[0].trim()
}
